import { render } from "./Product.vue?vue&type=template&id=3cf4ef6f"
import script from "./Product.vue?vue&type=script&setup=true&lang=js"
export * from "./Product.vue?vue&type=script&setup=true&lang=js"

import "./Product.vue?vue&type=style&index=0&id=3cf4ef6f&lang=css"

import exportComponent from "/Volumes/ext/winglet/license/grm/webpack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Product.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3cf4ef6f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3cf4ef6f', __exports__)) {
    api.reload('3cf4ef6f', __exports__)
  }
  
  module.hot.accept("./Product.vue?vue&type=template&id=3cf4ef6f", () => {
    api.rerender('3cf4ef6f', render)
  })

}


export default __exports__